
import { Vue, Component } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";

@Component
export default class SitemapSectionListPage extends Vue {
  dataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 50,
      orderFieldName: "Priority",
      orderFieldDirection: "ASC",
    },
    className: "sitemapSection",
  });

  createItemFields: any[] = [
    {
      name: "caption",
      editor: "string",
      attrs: { type: "text", label: "Подпись" },
      validations: [{ validator: "required" }],
    },
    {
      name: "name",
      editor: "systemname",
      attrs: { type: "text", label: "Системное имя (name)" },
      validations: [{ validator: "required" }],
    },
    {
      name: "autoSourceClassId",
      editor: "number",
      attrs: { type: "number", label: "ClassId автозагрузки (например 14-врачи)" },
      validations: [],
    },
    {
      name: "autoLimit",
      editor: "number",
      attrs: { type: "number", label: "Лимит автозагрузки (0 = без лимита)" },
      validations: [],
    },
    {
      name: "isActive",
      editor: "bool",
      attrs: { label: "Активен" },
      validations: [],
    },
    {
      name: "parentId",
      editor: "number",
      attrs: { type: "number", label: "Родительский раздел (ID, необязательно)" },
      validations: [],
    },
  ];

  createItemModel: any = {
    caption: "",
    name: "",
    autoSourceClassId: null,
    autoLimit: 0,
    isActive: true,
    parentId: null,
    instanceStateId: 4,
  };

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Карта сайта",
        disabled: true,
      },
    ];
  }
}
